import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAcneGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.993 10.023c0 1.123.896 2.033 2.012 2.033s2.02-.92 2.02-2.033A2.03 2.03 0 0 0 24.006 8c-1.107 0-2.012.9-2.012 2.023Zm1.203 0a.81.81 0 0 1 .809-.813c.452 0 .818.358.818.813a.826.826 0 0 1-.818.823.818.818 0 0 1-.809-.823Zm-1.203 27.944c0 1.123.896 2.033 2.012 2.033s2.02-.92 2.02-2.033a2.03 2.03 0 0 0-2.02-2.023c-1.107 0-2.012.9-2.012 2.023Zm1.203 0a.81.81 0 0 1 .809-.813c.452 0 .818.368.818.813a.826.826 0 0 1-.818.823.818.818 0 0 1-.809-.823Zm14.793-12.04a2.027 2.027 0 0 1-2.021-2.033 2.016 2.016 0 1 1 4.032 0c0 1.113-.895 2.032-2.011 2.032Zm0-2.846a.818.818 0 1 0 0 1.635.812.812 0 0 0 .808-.822.803.803 0 0 0-.808-.813ZM8 23.893c0 1.122.905 2.032 2.021 2.032 1.116 0 2.021-.92 2.021-2.032a2.025 2.025 0 0 0-2.02-2.023c-1.117 0-2.022.9-2.022 2.023Zm1.203 0a.818.818 0 1 1 1.635.009.818.818 0 0 1-1.635-.01Z",
    fill: "currentColor"
  }));
}

export { SvgAcneGlyph as default };
